import React, { useEffect, useState } from 'react';
import { Routes, Route, Outlet } from "react-router-dom";
import Sidebar from "../../layouts/sidebar/Sidebar"
import './Dashboard.css';
import Header from "../../layouts/header/Header"
import { getModulePermissions } from '../../apis/authApi/authApi';
import { CircularProgress } from '@mui/material';
import { useNavigate } from "react-router-dom";

function Dashboard() {

  const navigate = useNavigate();
  const [modulePermissions, setModulePermissions] = useState([])

  useEffect(() => {
    getModulePermissions((res: any) => {
      setModulePermissions(res);
      localStorage.setItem("permissionsData", JSON.stringify(res));
    });
  }, []);
 
  return (
    <div id="main">
          {modulePermissions.length === 0 ? 
            <div style={{height: "700px", display:"flex", alignItems : "center", justifyContent: "center"}}> <CircularProgress size={60} color='secondary'/> </div>
          : 
            <div className="dashboard-container" id="dashboard" >


              <Sidebar permissions={modulePermissions}/>


              <div className='main-content-div' >
              <Header />
                {/* <Header /> */}
                {/* Common Components */}
                <Outlet />
                {/* Common Components */}

              </div>
              {/* <div className="mobileSideBar_footer" id="footer">
                <footer className='footerMob' id="footerVal"><img src={poweredByP360} alt="" /></footer>
              </div> */}
            </div>
          }
       </div>
          
  );
}

export default Dashboard;
